import Vue from 'vue';
import Router from 'vue-router';
import qs from 'qs';
import Home from '@/views/Home.vue';
import Directory from '@/views/Directories.vue';
import Record from '@/views/Record.vue';
import Expert from '@/views/Expert.vue';
import Error404 from '@/views/404.vue';
import store from '@/store';

Vue.use(Router);

const meta = {
  title: `${store.state.name} Directory`,
  metaTags: [
    {
      name: 'description',
      content: store.state.meta_description,
    },
  ],
};

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta,
    },
    {
      path: '/404',
      name: '404',
      component: Error404,
      meta,
    },
    {
      path: '/expert',
      name: 'expert',
      component: Expert,
      meta,
    },
    {
      path: '/:directory',
      name: 'directory',
      component: Directory,
      meta,
      props: route => ({ parameters: route.query }),
    },
    {
      path: '/:directory/:record',
      name: 'record',
      component: Record,
      meta,
    },
  ],
  parseQuery(query) {
    return qs.parse(query);
  },
  stringifyQuery(query) {
    const result = qs.stringify(query);

    return result ? `?${result}` : '';
  },
});
